import {
  BETA_INDSTOCKS_HOST,
  INDGLOBAL_HOST,
  INDSTOCKS_HOST,
} from '@/root/constants/common'
import TradingViewIconSvg from '@/stories/assets/common/trading-view.inline.svg'

export const loggedOutNavLinks = [
  {
    text: 'Features',
    link: '/features',
    dontShowOn: [
      // { host: INDSTOCKS_HOST, pathnameExact: '/' },
      { host: INDGLOBAL_HOST, pathnameExact: '/' },
      // { host: BETA_INDSTOCKS_HOST, pathnameExact: '/' },
    ],
  },
  {
    text: 'Pricing',
    link: '/pricing?type=indian-stocks',
    navlinks: [
      { host: INDSTOCKS_HOST, pathnameExact: '/pricing?type=indian-stocks' },
      { host: INDGLOBAL_HOST, pathnameExact: '/pricing?type=us-stocks' },
    ],
  },
  {
    text: 'Blog',
    link: '/blog',
    dontShowOn: [
      { host: INDSTOCKS_HOST, pathnameExact: '/' },
      { host: INDGLOBAL_HOST, pathnameExact: '/' },
      { host: BETA_INDSTOCKS_HOST, pathnameExact: '/' },
    ],
  },
  {
    text: 'Customer Service',
    link: '/customer-service',
    showOnlyOn: [
      // {
      //   host: INDSTOCKS_HOST,
      //   pathnameExact: '/',
      // },
      {
        host: INDGLOBAL_HOST,
        pathnameExact: '/',
      },
      // { host: BETA_INDSTOCKS_HOST, pathnameExact: '/' },
    ],
    navlinks: [
      {
        host: INDSTOCKS_HOST,
        pathnameExact: '/customer-service?topic_id=9&searchFilter=FAQ',
      },
      {
        host: INDGLOBAL_HOST,
        pathnameExact: '/customer-service?topic_id=11&searchFilter=FAQ',
      },
    ],
  },
]

export const loggedInNavLinks = [
  {
    text: 'Dashboard',
    link: '/dashboard',
    nativeAnchor: false,
    type: '/dashboard',
  },
  {
    text: 'INDstocks',
    link: `https://${INDSTOCKS_HOST}/app/stocks/my-stocks/nifty-50`,
    nativeAnchor: false,
    type: '/stocks',
  },
  {
    text: 'Mutual Funds',
    link: '/investments/mutual-fund/explore-all',
    nativeAnchor: false,
    type: '/mutual-fund',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },

  {
    text: 'Fixed Deposits',
    link: '/investments/fixed-deposit/explore-all',
    nativeAnchor: false,
    type: '/fixed-deposit',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
  {
    text: 'US Stocks',
    link: '/investments/us-stocks/explore-all',
    nativeAnchor: false,
    type: '/us-stocks',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
]

export const loggedInNavLinksWithFnO = [
  { text: 'MyIND', link: '/dashboard', type: '/dashboard' },
  {
    text: 'US Stocks',
    link: '/investments/us-stocks/explore-all',
    type: '/us-stocks',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
  {
    text: 'Mutual Funds',
    link: '/investments/mutual-fund/explore-all',
    type: '/mutual-fund',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
  {
    text: 'INDstocks',
    link: `/investments/stocks/explore-all`,
    type: '/stocks',
  },
  {
    text: 'F&O',
    link: `https://${INDSTOCKS_HOST}/app/flash/nifty-50`,
    type: '/futures-and-options',
  },
  {
    text: 'Flash Trading',
    link: `https://${INDSTOCKS_HOST}/app/flash/nifty-50`,
    type: '/flash',
    openingInNewTab: true,
  },
  {
    link: `https://${INDSTOCKS_HOST}/app/tv`,
    icon: TradingViewIconSvg,
    type: '/chart',
    openingInNewTab: true,
    title: 'Chart',
  },
  {
    text: 'Algo Trading',
    link: `https://${INDSTOCKS_HOST}/app/api-trading`,
    type: '/api-and-algo-trading',
    openingInNewTab: true,
    title: 'API and Algo Trading',
  },
]
